
import { PageContainer } from "@/components/ui/page-container";
import { useJournalData } from "@/hooks/useJournalData";
import { useState } from "react";
import { Grid } from "@/components/ui/grid";
import { JournalHeader } from "@/components/journal/JournalHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { JournalEntries } from "@/components/journal/JournalEntries";
import { JournalAnalytics } from "@/components/journal/analytics/JournalAnalytics";
import { JournalReminders } from "@/components/journal/reminders/JournalReminders";
import { UserHealthDashboard } from "@/components/journal/dashboard/UserHealthDashboard";
import { JournalEmptyState } from "@/components/journal/JournalEmptyState";
import { AccessRequestsList } from "@/components/journal/access-requests/AccessRequestsList";
import { UserRequestsSection } from "@/components/journal/requests/UserRequestsSection";
import { JournalForm } from "@/components/journal/JournalForm";

const Journal = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("all");
  const [sort, setSort] = useState("newest");
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  const { 
    entries, 
    isLoading, 
    moodData, 
    symptomsFrequency,
    totalEntries 
  } = useJournalData(searchTerm, filter, sort);

  const handleNewEntry = () => {
    setIsFormOpen(true);
  };

  return (
    <PageContainer 
      title="Journal de Santé"
      variant="default"
      className="py-6"
    >
      <div className="space-y-6">
        <JournalHeader 
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          onFilterChange={setFilter}
          onSortChange={setSort}
          onNewEntry={handleNewEntry}
        />
        
        <Tabs defaultValue="entries" className="w-full">
          <div className="flex justify-center mb-4">
            <TabsList className="inline-flex rounded-full p-1 bg-muted/80">
              <TabsTrigger value="entries" className="rounded-full px-4">Entrées</TabsTrigger>
              <TabsTrigger value="analytics" className="rounded-full px-4">Analytique</TabsTrigger>
              <TabsTrigger value="requests" className="rounded-full px-4">Demandes & Reçus</TabsTrigger>
              <TabsTrigger value="reminders" className="rounded-full px-4">Rappels</TabsTrigger>
              <TabsTrigger value="access" className="rounded-full px-4">Accès</TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="entries" className="space-y-6">
            {/* Banner with empty state or entries */}
            <div className="col-span-8">
              {totalEntries === 0 ? (
                <JournalEmptyState />
              ) : (
                <JournalEntries entries={entries} isLoading={isLoading} />
              )}
            </div>
            
            {/* Health Dashboard */}
            <UserHealthDashboard />
            
            {/* Reminders Section */}
            <div className="mt-8">
              <JournalReminders />
            </div>
          </TabsContent>
          
          <TabsContent value="analytics">
            <JournalAnalytics 
              moodData={moodData} 
              symptomsFrequency={symptomsFrequency}
            />
          </TabsContent>
          
          <TabsContent value="requests">
            <UserRequestsSection />
          </TabsContent>
          
          <TabsContent value="reminders">
            <JournalReminders />
          </TabsContent>
          
          <TabsContent value="access">
            <AccessRequestsList />
          </TabsContent>
        </Tabs>
        
        {/* Journal Entry Form */}
        <JournalForm 
          open={isFormOpen}
          onOpenChange={setIsFormOpen}
        />
      </div>
    </PageContainer>
  );
};

export default Journal;
